import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../../../utils/common'
import {
  ICON_COLOR,
  ICON_HEIGHT_24,
  IconNG,
  IconSpinner,
} from '../../../../Icon'
import Text from '../../../../Text'
import {
  PHOTO_MAX_SIZE_MB,
  QA_NAME_PHOTO_ERROR,
} from '../../RentalPortalPhotoGallery.constants'
import {
  getIsPhotoRetriable,
  getPhotoErrorTextKey,
} from '../../RentalPortalPhotoGallery.utils'
import { RentalPortalPhotoGalleryTileOverlay } from '../../RentalPortalPhotoGalleryTileOverlay'

import * as styles from './RentalPortalPhotoGalleryTileUploadState.module.css'

import ErrorIcon from '../../../../../icons/error.svg'

function RentalPortalPhotoGalleryTileUploadState({
  disabled,
  disabledReason,
  hasError,
  photo,
  photoName,
  onRemove,
  onRetry,
}) {
  const { t } = useTranslation()

  return (
    <>
      <div
        {...(hasError ? getQaSelector({ value: QA_NAME_PHOTO_ERROR }) : null)}
        className={styles.RentalPortalPhotoGalleryTileUploadState}
      >
        {hasError ? (
          <>
            <IconNG
              Icon={ErrorIcon}
              color={ICON_COLOR.Red}
              size={ICON_HEIGHT_24}
            />
            <Text className={styles.errorText}>
              {t(getPhotoErrorTextKey(photo), { size: PHOTO_MAX_SIZE_MB })}
            </Text>
          </>
        ) : (
          <IconSpinner size={ICON_HEIGHT_24} />
        )}
        {photoName ? (
          <Text isSecondary className={styles.name}>
            {photoName}
          </Text>
        ) : null}
      </div>
      <RentalPortalPhotoGalleryTileOverlay
        className={styles.overlay}
        disabled={disabled}
        disabledReason={disabledReason}
        onRemove={onRemove}
        onRetry={hasError && getIsPhotoRetriable(photo) ? onRetry : undefined}
      />
    </>
  )
}

export default RentalPortalPhotoGalleryTileUploadState
